import { mutatorAction } from 'satcheljs';
import { getGroupFolder } from '../selectors/getGroupFolder';

export const updateGroupFolderUnreadCount = mutatorAction(
    'updateGroupFolderUnreadCount',
    function updateGroupFolderUnreadCount(groupId: string, folderId: string, unreadCount: number) {
        const groupFolder = getGroupFolder(groupId, folderId);

        if (groupFolder) {
            groupFolder.UnreadItemCount = unreadCount;
        }
    }
);
